export enum MobileNavigationBarItemSize {
  NORMAL,
  SMALL
}
